import GeoIcon from './component'

export default GeoIcon
